import { render } from "./AdminLogsList.vue?vue&type=template&id=37f9b446"
import script from "./AdminLogsList.vue?vue&type=script&lang=js"
export * from "./AdminLogsList.vue?vue&type=script&lang=js"

import "./AdminLogsList.vue?vue&type=style&index=0&id=37f9b446&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__